export const Role = {
  ADMIN: 'admin',
  OPERATORE: 'operatore',
  VISUALIZZATORE: 'visualizzatore'
} as const;

export type Role = typeof Role[keyof typeof Role];

export interface User {
  id: string;
  username: string;
  email: string;
  nome: string;
  cognome: string;
  ruolo: Role;
  isActive: boolean;
  tipologieScadenzeAssegnate?: Array<{
    id: string;
    _id?: string; // fallback per compatibilità
    nome: string;
    descrizione?: string;
  }>;
  createdAt: string;
  updatedAt: string;
}

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface LoginResponse {
  user: User;
  accessToken: string;
  refreshToken: string;
}

export interface AuthState {
  user: User | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  loading: boolean;
}
